<template><SimpleModuleDashboard :module-id="Modules.PERSONAL" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" :widget-filter="filterWidgets" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    staffNotes: Helper.hasParametersAccess(Param.P25),
    actions: [{ id: 'crud', reference: 'crud', route: 'StaffListStaff', tone: 'primary' }],
  }),
  methods: {
    filterWidgets(widget) {
      if(widget.php_id > 0 || widget.external_url || widget.height) return false
      return widget.reference !== 'list_staff_with_observations' || this.staffNotes
    },
  },
}
</script>
